import React from 'react'

const Product = ({name, description, link, image}) => {
  return (
    <div className="card sug-card">
        <a href={link} target="_blank" rel="noopener noreferrer">
            <div className="row align-items-center">
                <div className="col-4">
                    <img border="0" src={image} alt={name} />
                </div>
                <div className="col-8">
                    <h4>{name}</h4>
                    <p>{description}</p>
                    <span style={{backgroundColor: '#000', color: '#fff', padding: '10px 20px', textTransform: 'uppercase'}}>Check it now</span>
                </div>
            </div>
        </a>
    </div>
  )
}

export default Product
